var React = require('react');

function ThumbsUp (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"32","cy":"32","r":"32","fill":"#7C93FF","key":0}),React.createElement("path",{"d":"M23.1429 43.5H38.8571V24.975L28.8571 15L27.0714 16.7812C26.9048 16.9475 26.7679 17.1731 26.6607 17.4581C26.5536 17.7431 26.5 18.0162 26.5 18.2775V18.7762L28.0714 24.975H18.8571C18.0952 24.975 17.4286 25.26 16.8571 25.83C16.2857 26.4 16 27.065 16 27.825V30.675C16 30.8412 16.0238 31.0194 16.0714 31.2094C16.119 31.3994 16.1667 31.5775 16.2143 31.7437L20.5 41.79C20.7143 42.265 21.0714 42.6687 21.5714 43.0012C22.0714 43.3337 22.5952 43.5 23.1429 43.5ZM36 40.65H23.1429L18.8571 30.675V27.825H31.7143L29.7857 19.9875L36 26.1862V40.65ZM38.8571 24.975V27.825H43.1429V40.65H38.8571V43.5H46V24.975H38.8571Z","fill":"white","key":1})]);
}

ThumbsUp.defaultProps = {"width":"64","height":"64","viewBox":"0 0 64 64","fill":"none"};

module.exports = ThumbsUp;

ThumbsUp.default = ThumbsUp;
